module.exports = __webpack_public_path__ + "static/media/ogl1.png.8f44219d.jpg";